export var DropdownStyles = function (props) {
    var theme = props.theme;
    if (!theme) {
        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
    }
    return {
        title: [
            {
                borderColor: theme.palette.neutralSecondary
            }
        ]
    };
};
//# sourceMappingURL=Dropdown.styles.js.map